(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const init=()=>{const nodes=document.querySelectorAll('.aa>*,.ac>*,.ap>*,.aj>*,.ads>header,.ads-chapter,.ak>*,.acl>*,.ht-header,.ht-node');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('atelier-motion-visible');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -7%'});nodes.forEach(node=>{if(node.dataset.atelierMotion)return;node.dataset.atelierMotion='true';node.classList.add('atelier-motion-item');observer.observe(node)});const hero=document.querySelector('.ah-hero');const media=hero&&hero.querySelector('.ah-hero__media');if(media&&!media.dataset.ahParallax){media.dataset.ahParallax='1';let frame=null;const apply=()=>{frame=null;const limit=hero.offsetHeight*.15;const y=Math.max(0,Math.min(window.scrollY*.25,limit));media.style.transform='translate3d(0,'+y.toFixed(2)+'px,0)'};const request=()=>{if(frame===null)frame=requestAnimationFrame(apply)};window.addEventListener('scroll',request,{passive:true});window.addEventListener('resize',request,{passive:true});apply()}};init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harbor-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAtelier = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = root.querySelectorAll('.atelier-intro > *, .atelier-duo__card, .atelier-market header, .atelier-products article, .atelier-origin > *, .atelier-chronicle > header, .atelier-chronicle__image, .atelier-chronicle__chapters article, .atelier-serve > *, .atelier-closing > *');
    targets.forEach((item) => {
      item.classList.add('atelier-reveal');
      if (item.matches('.atelier-duo__card, .atelier-chronicle__image, .atelier-closing__image')) item.classList.add('atelier-reveal--image');
    });
    root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((item) => observer.observe(item));
  };
  document.querySelectorAll('.atelier').forEach(initAtelier);
  document.addEventListener('shopify:section:load', (event) => initAtelier(event.target.querySelector('.atelier')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-timeline"] && !Shopify.designMode) return;
  try {
    (()=>{const reduce=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;const run=node=>{const year=node.querySelector('.ht-node__year');if(!year)return;const raw=(year.dataset.htYear||'').trim();const parts=raw.match(/^(\D*)(\d+)(\D*)$/);if(!parts||reduce()){year.textContent=raw;return}const pre=parts[1];const target=parseInt(parts[2],10);const post=parts[3];const width=parts[2].length;const start=Math.max(0,target-60);const t0=performance.now();const step=now=>{const p=Math.min(1,(now-t0)/1100);const eased=1-Math.pow(1-p,3);year.textContent=pre+String(Math.round(start+(target-start)*eased)).padStart(width,'0')+post;if(p<1)requestAnimationFrame(step);else year.textContent=raw};requestAnimationFrame(step)};const init=()=>{const nodes=document.querySelectorAll('.ht-node');if(!nodes.length)return;const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-active');run(entry.target);observer.unobserve(entry.target)}}),{threshold:.35});nodes.forEach(node=>{if(node.dataset.htBound)return;node.dataset.htBound='true';observer.observe(node)})};init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
